import React from 'react';
import { useFormContext } from 'react-hook-form';
import PaymentDonutChart from '../PaymentDonutChart/PaymentDonutChart.js';
import { useLastValidMortgageValues } from './MortgageCalculator.utils.js';

function MortgageDonutChart() {
  var form = useFormContext();
  var lastValidValues = useLastValidMortgageValues(form);
  var chartDataProps = {
    monthlyPayment: lastValidValues.calculations.monthlyPayment,
    monthlyPI: lastValidValues.calculations.monthlyPI,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyTaxes : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyInsurance : 0,
    monthlyPMI: lastValidValues.fields.includePMI ? lastValidValues.calculations.monthlyPMI : 0,
    monthlyHOA: lastValidValues.fields.hoa
  };
  return /*#__PURE__*/React.createElement(PaymentDonutChart, chartDataProps);
}

export { MortgageDonutChart as default };
